// 261023 E3-P3h4c (FE) — chữ đầu «hộp hậu quả» + HỘP CŨ (fallback khi preview không dùng được). Hộp cũ giữ NGUYÊN chữ trước lát này. THUẦN.
import { dangerCopy } from './workbenchView';

export interface ConsCopy { title: string; lead: string; okText: string; fallback: string }

const OVERVIEW_UNAPPROVE_OLD = 'Khung xương về bản nháp: phải "Chốt tổng quan" lại mới chia tập / viết tiếp. Biên nhận chốt hiện tại bị xoá; bản đã chốt vẫn còn ở danh sách phiên bản ②. Các tập đã có không tự đổi.';

/** Bỏ duyệt khung xương (truyện dùng tổng quan: «Mở tổng quan để sửa»). */
export const unapproveCopy = (usesOverview: boolean): ConsCopy => {
  if (usesOverview) {
    return { title: 'Mở tổng quan để sửa?', lead: 'Khung xương quay về bản nháp — phải chốt tổng quan lại mới chạy tiếp các bước sau.', okText: 'Mở để sửa', fallback: OVERVIEW_UNAPPROVE_OLD };
  }
  const old = dangerCopy('unapprove');
  return { title: old.title, lead: 'Khung xương quay về bản nháp — phải duyệt lại mới chạy tiếp các bước sau.', okText: old.okText, fallback: old.content };
};

/** Xoá một từ vựng bản địa hoá. */
export const glossaryDeleteCopy = (originalTerm: string, localizedTerm: string): ConsCopy => ({
  title: `Xoá từ “${originalTerm}”?`,
  lead: localizedTerm.trim() ? `Từ “${originalTerm}” → “${localizedTerm}” bị gỡ khỏi bảng từ vựng.` : `Từ “${originalTerm}” bị gỡ khỏi bảng từ vựng.`,
  okText: 'Xoá từ',
  fallback: 'Kịch bản đã viết không bị đổi lại.',
});

/** Viết lại MỘT tập đã có kịch bản. */
export const rewriteCopy = (ep: number, versionCount: number): ConsCopy => {
  const old = dangerCopy('rewriteEpisode', { ep, versionCount });
  return { title: old.title, lead: `Máy viết lại toàn bộ kịch bản tập ${ep}.`, okText: old.okText, fallback: old.content };
};
